<template>
  <v-snackbar v-model="status" top color="orangePcm">
    {{ text }}
    <template v-slot:action="{ attrs }">
      <v-btn color="bluePcm" text v-bind="attrs" @click="status = false">
        Fechar
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "Snackbar",
  props: {
    text: String,
    snackbar: Boolean,
  },
  data: () => ({
    active: false,
  }),
  computed: {
    status: {
      get() {
        return this.active;
      },
      set(valor) {
        this.active = valor;
      },
    },
  },
  watch: {
    snackbar(novo) {
      this.active = novo;
    },
    active(novo) {
      this.$emit("change", novo);
    },
  },
};
</script>

<style scoped></style>
